import React, { useState, useContext, useEffect } from "react";
import ActiveCurrenciesContext from "../../providers/CurrencyProvider";
import classes from "../Table/Table.module.css";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import GlobalContext from "../../providers/GlobalProvider";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

const ActiveCurrencies = () => {
  const { defaultMapper } = useContext(GlobalContext);
  const { reloadActiveCurrencies } = useContext(ActiveCurrenciesContext);
  const [toggledItems, setToggledItems] = useState({});
  const [currencyList, setCurrencyList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCurrencyData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/api/Currency/matched`);
        setCurrencyList(response.data);
        const toggledItems = {};
        for (const currency of response.data) {
          if (currency.isActive) {
            toggledItems[currency.libraCurrency.code] = currency;
          }
        }
        setToggledItems(toggledItems);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (defaultMapper) {
      fetchCurrencyData();
    }
  }, [defaultMapper]);

  const handleToggle = (currencyMatch) => {
    const code = currencyMatch.codeCurrIds;
    const isCurrentlyActive = toggledItems[code];

    setToggledItems((prev) => {
      const newToggledItems = { ...prev };
      if (isCurrentlyActive) {
        delete newToggledItems[code];
        axios.post(`/api/Currency/deactivate`, currencyMatch).then(() => {
          reloadActiveCurrencies();
        });
      } else {
        newToggledItems[code] = currencyMatch;
        axios.post(`/api/Currency/activate`, currencyMatch).then(() => {
          reloadActiveCurrencies();
        });
      }

      return newToggledItems;
    });
  };

  if (loading) {
    return (
      <div>
        <ClipLoader
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <Table hover bordered="false" responsive order>
        <thead>
          <tr>
            <th>Currency</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {currencyList && currencyList.length > 0 ? (
            currencyList.map((obj) => (
              <tr key={obj.OpsCurrencyId}>
                <td>{obj.libraCurrency.symbol}</td>
                <td>
                  <Button
                    onClick={() => handleToggle(obj)}
                    variant={
                      toggledItems[obj.libraCurrency.code]
                        ? "outline-success"
                        : "outline-danger"
                    }
                  >
                    {!toggledItems[obj.libraCurrency.code]
                      ? "Inactive"
                      : "Active"}
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2">No Currencies Data.</td>
            </tr>
          )}
        </tbody>
      </Table>
      <div>
        <Link to="/">
          <Button variant="outline-danger">Main Menu</Button>
        </Link>
      </div>
    </>
  );
};

export default ActiveCurrencies;
